import _Input from './Input';
import _InputGroup from './InputGroup';

import './style/index.js';

export type { InputProps, InputRef } from './Input';
export type { InputGroupProps } from './InputGroup';
export * from './type';

export const Input = _Input;
export const InputGroup = _InputGroup;
export default Input;
